var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScatterChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.225,
    height: 28.225,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#185edf",
    stroke: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21570",
    d: "M27.725 27.725H2.445A1.945 1.945 0 0 1 .5 25.78V.5h1.945v25.28h25.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21571",
    d: "M11 19.543a2.25 2.25 0 1 1-2.25-2.25 2.25 2.25 0 0 1 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21572",
    d: "M14.788 12.915a2.25 2.25 0 1 1-2.25-2.25 2.25 2.25 0 0 1 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21573",
    d: "M22.362 12.915a2.25 2.25 0 1 1-2.25-2.25 2.25 2.25 0 0 1 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21574",
    d: "M25.794 4.75a2.25 2.25 0 1 1-2.25-2.25 2.25 2.25 0 0 1 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21575",
    d: "M11 6.288a2.25 2.25 0 1 1-2.25-2.25A2.25 2.25 0 0 1 11 6.288Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterChartBlue);
export default __webpack_public_path__ + "static/media/scatter-chart-blue.8bcd7309a0784cf2952a10f20f1a52ff.svg";
export { ForwardRef as ReactComponent };